export class TreatedImage {
    imageOriginal: File;
    imageCroppied: File;
}
